var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigmaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2348_5381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 26.2889C26.0002 24.8332 26.5785 23.4371 27.6079 22.4077C28.6373 21.3783 30.0334 20.8 31.4891 20.8C32.9449 20.8 34.341 21.3783 35.3704 22.4077C36.3997 23.4371 36.978 24.8332 36.978 26.2889C36.978 27.7447 36.3997 29.1408 35.3704 30.1702C34.341 31.1995 32.9449 31.7778 31.4891 31.7778C30.0334 31.7778 28.6373 31.1995 27.6079 30.1702C26.5785 29.1408 26.0002 27.7447 26.0002 26.2889Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0225 37.2667C15.0225 35.811 15.6008 34.4149 16.6301 33.3855C17.6595 32.3561 19.0556 31.7778 20.5114 31.7778H26.0002V37.2667C26.0002 38.7225 25.4219 40.1186 24.3926 41.148C23.3632 42.1773 21.9671 42.7556 20.5114 42.7556C19.0556 42.7556 17.6595 42.1773 16.6301 41.148C15.6008 40.1186 15.0225 38.7225 15.0225 37.2667V37.2667Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 9.82227V20.8H31.4891C32.9449 20.8 34.341 20.2218 35.3704 19.1924C36.3997 18.163 36.978 16.7669 36.978 15.3112C36.978 13.8554 36.3997 12.4593 35.3704 11.4299C34.341 10.4006 32.9449 9.82227 31.4891 9.82227H26.0002Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0225 15.3112C15.0225 16.7669 15.6008 18.163 16.6301 19.1924C17.6595 20.2218 19.0556 20.8 20.5114 20.8H26.0002V9.82227H20.5114C19.0556 9.82227 17.6595 10.4006 16.6301 11.4299C15.6008 12.4593 15.0225 13.8554 15.0225 15.3112V15.3112Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0225 26.2889C15.0225 27.7447 15.6008 29.1408 16.6301 30.1702C17.6595 31.1995 19.0556 31.7778 20.5114 31.7778H26.0002V20.8H20.5114C19.0556 20.8 17.6595 21.3783 16.6301 22.4077C15.6008 23.4371 15.0225 24.8332 15.0225 26.2889V26.2889Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2348_5381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9556,
    height: 32.9333,
    fill: "white",
    transform: "translate(15.0225 9.82227)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/figma-logo.7d0ea42d5b6e1894ef1218a082245f36.svg";
export { ForwardRef as ReactComponent };